import { ChangeDetectorRef, Component, QueryList, TemplateRef, ViewChild, ViewChildren } from '@angular/core';
import { ActivatedRoute, Router } from "@angular/router";
import {
  CtBinaryOperator,
  CtButtonConfiguration,
  CTDynamicFormGeneratorComponent,
  CtDynamicFormGeneratorConfiguration,
  CtModelConfiguration,
  CTModelDatatableFilter,
  CtModelDatatableOperators,
  CtModelRouteData, CtModelService,
  CtModelType,
  MAT_RAISED_PRIMARY,
} from "@ctsolution/ct-framework";
import { WorkOrderRouteData } from "../../../../_core/route-data/work-order.route-data";
import { CTWorkOrder } from "../../../../_core/classes/ct-work-order";
import { GeneralDataComponent } from "./general-data/general-data.component";
import { CTMWorkOrderViewType } from "../../../../_core/enum/work-order-type";
import { WorkOrderService } from "../../work-order.service";
import { GeneralDataConfiguration } from "./general-data/general-data.configuration";
import { MovementManagerComponent } from "./movement-manager/movement-manager.component";
import { CtManagerService } from "../../../../_core/lib/ct-manager.service";
import { CtWebapiGenericResponse, CtWebapiService, DataRequest, MethodEnum } from "@ctsolution/ct-webapi";
import { CTWorkOrderRow } from "../../../../_core/classes/ct-work-order.row";
import { CtWorkOrderInformationContent } from "../../../../_core/classes/ct-work-order.information-content";
import { CTWorkOrderRowUnionType } from "../../../../_core/classes/ct-work-order.row-union";
import { MovementManagerConfiguration } from "./movement-manager/movement-manager.configuration";
import { WorkOrderHandlingsConfiguration } from "./work-order-handlings/work-order-handlings.configuration";
import { WorkOrderDocumentsConfiguration } from './work-order-documents/work-order-documents.configuration';
import { TranslateService } from "@ngx-translate/core";
import { LangDownloadFileConfiguration, WorkOrderRowsExportTypeVO } from '../../../lang-download-file/lang-download-file.configuration';
import { WorkOrderDownloadMenuConfiguration } from '../../../work-order-download-menu/work-order-download-menu.configuration';
import { ReportDownloadParameter } from 'projects/ct-manager/src/app/_core/classes/report-download.parameter';
import { PackagingService } from '../../work-order-packaging/work-order-packaging/work-order-packaging.service';
import { WorkOrderLocationConfiguration } from './work-order-location/work-order-location.configuration';
import { SchedulerListConfiguration } from '../../../scheduler/scheduler-list/scheduler-list.configuration';
import { SchedulerService } from '../../../scheduler/scheduler.service';
import { WorkOrderPackagingConfiguration } from '../../work-order-packaging/work-order-packaging/work-order-packaging.configuration';
import { CTConfigurationModel } from 'projects/ct-manager/src/app/_core/classes/ct-configuration-model';
import { WorkOrderEditTemplateComponent } from './work-order-edit-template/work-order-edit-template.component';
import { WorkOrderEditTemplateConfiguration } from './work-order-edit-template/work-order-edit-template.configuration';
import { WorkOrderDynamicFormService } from './work-order-dynamic-form.service';
import { lastValueFrom } from 'rxjs';
import { WorkOrderDynamicFormDataParameter } from './work-order-dynamic-form/work-order-dynamic-form.component';
import { ReportController } from 'projects/ct-manager/src/app/_core/controllers/report.controller';
import { CtFileManagementService } from '@ctsolution/ct-file-management';
import { MatLegacyDialog as MatDialog } from "@angular/material/legacy-dialog";
import { WorkOrderQuotationDialogComponent, WorkOrderQuotationDialogResult } from './work-order-quotation-dialog/work-order-quotation-dialog.component';
import { WorkOrderEventLogDialogComponent, WorkOrderEventLogDialogData } from './work-order-event-log-dialog/work-order-event-log-dialog.component';
import {
  MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";


@Component({
  selector: 'app-work-order-default-edit',
  templateUrl: `./work-order-default-edit.component.html`,
  styleUrls: [`./work-order-default-edit.component.scss`],
  providers: [{ provide: MatDialogRef, useValue: {} }]
})
export class WorkOrderDefaultEditComponent {

  pId: string | null = null;
  configuration: CtModelConfiguration<WorkOrderDefaultEditComponent> | null = null;
  existingData: WorkOrderDynamicFormDataParameter | null = null;

  @ViewChild("headerActions") headerActions: TemplateRef<any> | null = null;
  @ViewChild("EDITOR") editor?: WorkOrderEditTemplateComponent;

  downloadDynamicFormPdf: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("Download pdf")
    .setMatherialOptions(MAT_RAISED_PRIMARY)
    .setIcon("download");

  downloadDynamicFormExcel: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("Download excel")
    .setMatherialOptions(MAT_RAISED_PRIMARY)
    .setIcon("download");

  // Bottone per aprire la modale dei log eventi del WorkOrder
  eventLogButtonConfiguration: CtButtonConfiguration = CtButtonConfiguration
    .create()
    .setLabel("Log Eventi")
    .setMatherialOptions(MAT_RAISED_PRIMARY)
    .setIcon("history")
    .setAction(() => this.openEventLogDialog())
    .setVisible(false); // Visibile solo in modalità edit (masterDetail = true)

  viewModel: WorkOrderDefaultEditViewModel = {
    workOrder: null,
    workOrderViewType: CTMWorkOrderViewType.Standard,
    workOrderRowHandlingEnabled: false,
    workOrderExtraDataEnabled: false,
    workOrderCalendarEnabled: false,
    selectedIndex: 0,
    masterDetail: false,
    offerEnabled: false,

  }

  /**
   * Configurazione legacy per il download del PDF (lang-download-file)
   * Viene utilizzata quando workOrderDownloadMenuConfiguration.enabled = false
   */
  langDownloadFileConfiguration: LangDownloadFileConfiguration = LangDownloadFileConfiguration
    .create()
    .setColor("accent")
    .setIcon("picture_as_pdf")
    .setButtonType('mat-mini-fab')
    .setLanguage([
      {
        language: "Italiano",
        code: "it",
        type: "IT",
        icon: "it"
      }]);

  /**
   * Configurazione per il nuovo componente di download con menu avanzato
   * Può essere sovrascritta tramite il sistema di override del CtManagerService
   * Se enabled = false, viene utilizzato il componente legacy
   */
  workOrderDownloadMenuConfiguration: WorkOrderDownloadMenuConfiguration = WorkOrderDownloadMenuConfiguration
    .create()
    .setEnabled(false) // Di default il nuovo componente è abilitato
    .setMaxDocumentsToShow(5)
    .setColor("accent")
    .setIcon("picture_as_pdf")
    .setButtonType('mat-mini-fab')
    .setGeneratedPdfLabel("PDF Generato")
    .setUploadedDocumentsLabel("Documenti Caricati")
    .setShowFileIcon(true)
    .setLanguages([
      {
        language: "Italiano",
        code: "it",
        type: "IT",
        icon: "it"
      }
    ]);

  generalDataConfiguration: GeneralDataConfiguration | null = null;
  movementManagerConfiguration: MovementManagerConfiguration | null = null;
  workOrderHandlingsConfiguration: WorkOrderHandlingsConfiguration | null = null;
  workOrderDocumentsConfiguration: WorkOrderDocumentsConfiguration | null = null;
  workOrderLocationConfiguration: WorkOrderLocationConfiguration | null = null;
  workOrderEditTemplateConfiguration: WorkOrderEditTemplateConfiguration | null = null;
  workOrderDynamicTabFormConfiguration: WorkOrderDynamicTabFormConfiguration | null = null;
  workOrderTaskTabConfiguration: CTConfigurationModel | null = null;


  @ViewChildren('formGenerator') formGeneratorComponents: QueryList<CTDynamicFormGeneratorComponent> | null = null;

  schedulerListConfiguration: SchedulerListConfiguration | null = null;
  workOrderSummaryConfiguration: CTConfigurationModel | null = null;



  creaPackagingButtonConfiguration: CtButtonConfiguration | null = null;

  @ViewChild('generalDataComponent') generalDataComponent: GeneralDataComponent | null = null;
  @ViewChild('movementManagerComponent') movementManagerComponent: MovementManagerComponent | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private translate: TranslateService,
    private workOrderService: WorkOrderService,
    private managerService: CtManagerService,
    private CTModelService: CtModelService<any>,
    private packagingService: PackagingService,
    private schedulerService: SchedulerService,
    private workOrderDynamicFormService: WorkOrderDynamicFormService,
    private reportController: ReportController,
    private webapiService: CtWebapiService,
    private fileManagementService: CtFileManagementService,
    private dialogService: MatDialog,
  ) {

    this.pId = this.route.snapshot.paramMap.get("id");

  }

  ngOnInit() {

    this.setup();

  }

  resetTemplate(event: any) {

    if (event.tab.textLabel == this.translate.instant('CustomTemplate')) {
      this.editor?.tinyEditor?.setup();
    }

  }

  ngAfterViewInit() {

    this.route
      .queryParams
      .subscribe(qp => {

        if (qp['rows']) {

          setTimeout(() => this.viewModel.selectedIndex = 1, 200)

        }

      })

    this.route
      .data
      .subscribe(data => {

        data['headerActions'] = this.headerActions;

      });

  }

  get isQuotation() {

    return this.viewModel.workOrderViewType === CTMWorkOrderViewType.Quotation;

  }

  async setup() {

    this.viewModel.workOrderViewType = await this.workOrderService.getRouteWorkOrderType(this.route);


    // Applica l'override per la configurazione legacy (compatibilità)
    await this.managerService.getComponentOverride("workOrder", "langDownloadFileConfiguration", this.langDownloadFileConfiguration).then((component) => {
      return;
    });

    // Applica l'override per la nuova configurazione del menu di download
    // Se si vuole disabilitare il nuovo componente e tornare al legacy, impostare enabled = false nell'override
    await this.managerService.getComponentOverride("workOrder", "workOrderDownloadMenuConfiguration", this.workOrderDownloadMenuConfiguration).then((component) => {
      return;
    });

    this.viewModel.workOrderExtraDataEnabled = await this.managerService.hasEnabled.monitoring();
    this.viewModel.workOrderCalendarEnabled = await this.managerService.hasEnabled.calendar();


    const routeData: CtModelRouteData = WorkOrderRouteData()
      .setModelType(CtModelType.FORM);

    if (this.pId) {

      routeData.setId(+this.pId);
      this.viewModel.workOrderRowHandlingEnabled = await this.managerService.hasEnabled.warehouse();
      this.viewModel.masterDetail = true;

      // Abilita il bottone Event Log solo in modalità edit
      this.eventLogButtonConfiguration.setVisible(true);

      if (this.viewModel.workOrderCalendarEnabled) {

        const param = this.schedulerService.returnParam(+this.pId);
        // Configurazione scheduler con modale abilitata
        this.schedulerListConfiguration = new SchedulerListConfiguration(
          [CTModelDatatableFilter.create().setField('Workorder.Oid').setValue(+this.pId).setOperatorType(CtBinaryOperator.Equal)], 
          param
        )
        .setAction(() => this.submit(null))
        .setUseModal(true);  // Abilita l'apertura in modale invece della navigazione

      }

    }

    this.configuration = CtModelConfiguration
      .create<WorkOrderDefaultEditComponent>()
      .setRouteData(routeData);

    if (this.pId) {

      this.CTModelService
        .getInfos(this.configuration)
        .subscribe({
          next: async (response) => {

            if (response && response?.Result?.DataSource) {

              this.viewModel.workOrder = CTWorkOrder.create<CtWorkOrderInformationContent>(response?.Result?.DataSource);

              if (this.viewModel.workOrder.Oid) {

                const [rows, rowsItem, rowsOffer, rowsContact] = await Promise.all([
                  this.workOrderService.getRows(this.viewModel.workOrder.Oid).catch(error => []),
                  [], //this.workOrderService.getRowsItem(this.viewModel.workOrder.Oid).catch(error => []),
                  [], //this.workOrderService.getRowsOffer(this.viewModel.workOrder.Oid).catch(error => []),
                  [] //this.workOrderService.getRowsContact(this.viewModel.workOrder.Oid).catch(error => [])
                ]);

                this.route
                  .data.subscribe(data => {

                    const { title, code, referenceName } = {
                      title: this.translate.instant(this.isQuotation ? "QUOTATION" : "SingleWorkOrder"),
                      code: this.viewModel.workOrder?.Code ?? "",
                      referenceName: response?.Result?.DataSource.Company.ReferenceName ?? ""
                    };

                    //data['title'] = [title, code, referenceName].filter(Boolean).join(' - ');
                    data['title'] = `${title} ${code} - ${referenceName}`

                    this.cdr.detectChanges();

                    this.cdr.detectChanges();
                  })

                this.viewModel.workOrder.Rows = new Array<CTWorkOrderRowUnionType>();

                [rows, rowsItem, rowsOffer, rowsContact]
                  .forEach(rowArray => {

                    if (rowArray?.length) rowArray.forEach(r => this.viewModel.workOrder?.Rows.push(CTWorkOrderRow.create(r)));

                  });

                if (this.generalDataComponent) this.generalDataComponent.setup(this.viewModel.workOrder);

                if (this.movementManagerComponent) this.movementManagerComponent.setup(this.viewModel.workOrder);

              }
              this.creaPackagingButtonConfiguration = CtButtonConfiguration
                .create()
                .setLabel("CreatePackaging")
                .setAction(() => this.createPackaging())
                .setMatherialOptions(MAT_RAISED_PRIMARY)
                .setVisible(false);
              //Creazione configurazione button Crea Packaging nel click trasportare gli articoli presenti in commessa

              this.managerService.getComponentOverride("workOrder", "createPackaging", this.creaPackagingButtonConfiguration).then((component) => {
                return;
              });


            }

          },
          error: (err) => console.error('Errore durante il recupero delle informazioni:', err)
        })

    }

    this.generalDataConfiguration = GeneralDataConfiguration
      .create(this.viewModel.workOrderViewType)
      .setWorkOrderOid(this.pId ? +this.pId : null)
      .enableImport(this.viewModel.workOrderRowHandlingEnabled)
      .enableExtraDataJson(this.viewModel.workOrderExtraDataEnabled);

    await this.managerService.getComponentOverride("workOrder", "generalDataConfiguration", this.generalDataConfiguration).then((component) => {
      return;
    });


    this.movementManagerConfiguration = MovementManagerConfiguration
      .create()
      .setWorkOrderOid(this.pId ? +this.pId : null)
      .setIsQuotation(this.isQuotation)
      .setEnableWerehouse(this.viewModel.workOrderRowHandlingEnabled);

    this.managerService.getComponentOverride("workOrder", "movementManagerConfiguration", this.movementManagerConfiguration).then((component) => {
      return;
    });

    this.workOrderSummaryConfiguration = CTConfigurationModel.create()

    await this.managerService.getComponentOverride("workOrder", "workOrderSummaryConfiguration", this.workOrderSummaryConfiguration).then((component) => {
      return;
    });


    this.workOrderHandlingsConfiguration = WorkOrderHandlingsConfiguration
      .create()
      .setWorkOrderOid(this.pId ? +this.pId : null)

    this.workOrderDocumentsConfiguration = WorkOrderDocumentsConfiguration
      .create()
      .setWorkOrderOid(this.pId ? +this.pId : null)

    this.workOrderLocationConfiguration = WorkOrderLocationConfiguration
      .create()
      .setWorkOrderOid(this.pId ? +this.pId : null)

    this.workOrderEditTemplateConfiguration = WorkOrderEditTemplateConfiguration
      .create()
      .setWorkOrderOid(this.pId ? +this.pId : null)

    this.workOrderDynamicTabFormConfiguration = WorkOrderDynamicTabFormConfiguration
      .create()

    this.workOrderTaskTabConfiguration = CTConfigurationModel.create().setVisible(false);

    await this.managerService.getComponentOverride("workOrder", "workOrderDynamicTabFormConfiguration", this.workOrderDynamicTabFormConfiguration).then((component) => {

      return;
    });

    if (this.workOrderDynamicTabFormConfiguration.visible) await this.setupDynamicTabForm();

    await this.managerService.getComponentOverride("workOrder", "workOrderLocationConfiguration", this.workOrderLocationConfiguration).then((component) => {
      return;
    });

    await this.managerService.getComponentOverride("workOrder", "workOrderEditTemplateConfiguration", this.workOrderEditTemplateConfiguration).then((component) => {
      return;
    });

    await this.managerService.getComponentOverride("workOrder", "workOrderTaskTabConfiguration", this.workOrderTaskTabConfiguration).then((component) => {

      return;
    });


    this.route
      .data
      .subscribe(data => {

        data['title'] = (this.isQuotation) ? "CT_MENU.quotations" : "CT_MENU.workorder";
        data['urls'] = [{ title: (this.isQuotation) ? 'quotation-form' : 'workorder-form' }];

      })

    this.cdr.detectChanges();

  }

  submit(acceptQuotationDate: Date | null) {

    if (!this.configuration || this.generalDataComponent?.formConfiguration?.form?.invalid) return;

    const generalDataValue = this.generalDataComponent?.formConfiguration?.form?.value;

    if (!generalDataValue) {
      console.error('Dati non validi');
      return;
    }

    const workOrder = CTWorkOrder
      .create<CtWorkOrderInformationContent>()
      .setName(generalDataValue.Name)
      .setCompanyOid(generalDataValue.Company.value)
      .setCode(generalDataValue.Code)
      .setStateOid(generalDataValue.State)
      .setStartAt(generalDataValue.StartAt)
      .setExpiredAt(generalDataValue.ExpiredAt)
      .setAddress(generalDataValue.Address?.value ? generalDataValue.Address.label : generalDataValue.Address)
      .setDescription(generalDataValue.Description)
      .setExtraDataJSON(generalDataValue.ExtraDataJSON ?? null)
      .setCommission(generalDataValue.Commission);

    if (this.isQuotation) {

      workOrder.setQuotation(true);

      if (acceptQuotationDate) {
        workOrder.setQuotationAcceptAt(acceptQuotationDate);
        this.dialogService.open(WorkOrderQuotationDialogComponent, {})
          .afterClosed()
          .subscribe((result: WorkOrderQuotationDialogResult) => {

            // Se l'utente ha annullato, esci
            if (!result || result.Accepted === false) return;

            // Imposta il valore dalla modale
            workOrder.setCreateDocumentPdf(result.CreateDocumentPdf);

            // Ora procedi con il salvataggio
            this.saveWorkOrder(workOrder, acceptQuotationDate);
          });
      } else {

          this.saveWorkOrder(workOrder, acceptQuotationDate);

      }

      // Apri la modale e aspetta il risultato

    } else {
      // Se non è quotation, salva direttamente
      this.saveWorkOrder(workOrder, acceptQuotationDate);
    }
  }

  // Metodo separato per il salvataggio
  private saveWorkOrder(workOrder: any, acceptQuotationDate: Date | null) {
    this.CTModelService
      .putInfos(this.configuration!, workOrder)
      ?.subscribe({
        next: (response: CtWebapiGenericResponse<number | null>) => {
          const commands = ['/', 'work-order'];

          // Se è una creazione (response.Result è un nuovo ID)
          if (response.Result && !isNaN(response?.Result)) {
            if (this.isQuotation) commands.push('quotations');
            commands.push('edit', response.Result?.toString());
            this.router.navigate(commands);
          } 
          // Se è un'accettazione di quotation
          else if (this.pId && this.isQuotation && !!acceptQuotationDate) {
            commands.push('edit', this.pId);
            this.router.navigate(commands);
          } 
          // Se è un semplice update di un work-order esistente, NON fare il reload
          // La pagina resta com'è, permettendo allo scheduler modale di funzionare correttamente
          else {
            // Nessuna azione necessaria - il form è già salvato e la pagina resta stabile
            console.log('Work-order aggiornato con successo');
          }
        },
        error: (err) => console.error('Errore durante l\'operazione:', err)
      });
  }

  downloadPdf(lang : any) {

    if (!this.viewModel?.workOrder?.Oid) return;

    const parameter: ReportDownloadParameter = ReportDownloadParameter
      .create()
      .setWorkOrderOid(this.viewModel.workOrder.Oid)
      .setTemplateLanguage(lang.code ?? 'it')
      .setRowType(lang.rowType ?? WorkOrderRowsExportTypeVO.All)
      .setDirectDownload(false)
      .setOpenInBrowser(true)
      .setAction('WorkOrderPdf')
      .setLabelDownload(`WorkOrder${this.viewModel.workOrder.Oid}`);

    this.workOrderService.downloadWorkOrderPDF(parameter)


  }

  createPackaging() {

    if (!this.pId) return;

    const param = WorkOrderPackagingConfiguration.create();
    param.setWorkOrderOid(+this.pId)
    this.packagingService.openDialogPackaging(param);
  }


  async setupDynamicTabForm() {
    if (!this.pId) return; // Devo essere in edit

    const pid = +this.pId;
    const response = await lastValueFrom(this.workOrderDynamicFormService.getWorkOrderDynamicForms(5, 'TS'));

    const forms: Array<CtDynamicFormGeneratorConfiguration> = [];

    if (!response?.Result?.DataSource) return;

    for (const [idx, cnfg] of (<Array<any>>response.Result.DataSource).entries()) {
      const dynamicFormConfiguration = CtDynamicFormGeneratorConfiguration
        .create()
        .setFormGeneratorModel(cnfg);

      this.existingData = await this.workOrderDynamicFormService.getFormWorkOrderDataValue(cnfg.Oid, pid);

      dynamicFormConfiguration.setOnSubmit(async (filteredValue: any) => {
        try {
          const parameter: WorkOrderDynamicFormDataParameter = this.workOrderDynamicFormService.generateWorkOrderDynamicFormDataParameter({
            value: filteredValue.value,
            formGeneratorOid: dynamicFormConfiguration?.formGeneratorModel?.Oid ?? -1,
            workOrderOid: pid
          });

          if (this.existingData?.Oid) {
            parameter.setOid(this.existingData.Oid);
          }

          // Usando una Promise per gestire l'inserimento dei dati
          const response = await lastValueFrom(this.workOrderDynamicFormService.insertWorkOrderData(parameter));

          const updatedValue = response?.Result ?? this.existingData?.Oid ?? -1;
          if (!this.existingData) this.existingData = {} as WorkOrderDynamicFormDataParameter;
          (<any>this.existingData)['Oid'] = updatedValue;

          // Azione successiva
          this.setupDynamicTabForm();
        } catch (error) {
          // Gestione degli errori
          console.error("Errore durante l'inserimento dei dati", error);
        }
      });

      this.downloadDynamicFormPdf.setAction(() => this.downloadTabPdf(cnfg.Oid, pid, idx));

      dynamicFormConfiguration.setExtraActions([this.downloadDynamicFormPdf]);

      if (this.workOrderDynamicTabFormConfiguration?.exportExcel) {

        this.downloadDynamicFormExcel.setAction(() => this.downloadExcel(idx));
        dynamicFormConfiguration.extraActions?.push(this.downloadDynamicFormExcel);

      }


      if (this.existingData) {
        const parsedValue = JSON.parse(this.existingData.Content ?? '');
        setTimeout(() => this.setChildFormData(idx, parsedValue), 500);
      }

      forms.push(dynamicFormConfiguration);
    }

    this.workOrderDynamicTabFormConfiguration?.setDynamicForms(forms);

  }

  private setChildFormData(idx: number, value: any) {

    const references = this.formGeneratorComponents?.toArray() ?? [];

    const componentRef = references[idx];

    if (componentRef) {

      componentRef
        .form
        .patchValue(value);

    }

  }

  async downloadTabPdf(templateOid: number, pid: number, idx: number) {

    const references = this.formGeneratorComponents?.toArray() ?? [];

    const componentRef = references[idx];

    if (componentRef) {

      if (componentRef.submitButton.action) {

        await this.wrapActionInPromise(componentRef.submitButton.action, null);
      }

    }

    setTimeout(async () => {

      const parameter: ReportDownloadParameter = ReportDownloadParameter
        .create()
        .setWorkOrderOid(pid)
        .setDirectDownload(true)
        .setAction('WorkOrderTabPdf')
        .setFormTemplateOid(templateOid)
        .setLabelDownload(`Acuse_${pid}`)

      await lastValueFrom(this.reportController.getAnyPDF(parameter));

    }, 2000); //Diamo il tempo del salvataggio sopra


  }

  async downloadExcel(idx: number) {

    const references = this.formGeneratorComponents?.toArray() ?? [];

    const componentRef = references[idx];

    if (componentRef) {

      if (componentRef.submitButton.action) {

        await this.wrapActionInPromise(componentRef.submitButton.action, null);
      }

    }

    setTimeout(async () => {

      if (!this.existingData) return;

      const controller: string | undefined | null = this.configuration?.RouteData?.controller;

      const body = {

        WorkOrderDataOid: this.existingData?.Oid

      }

      if (!controller) return;

      const request: DataRequest = new DataRequest()
        .setController([controller])
        .setAction(`${this.workOrderDynamicTabFormConfiguration?.actionExcel}`)
        .setBody(body)
        .setMethod(MethodEnum.POST)
        .setResponseType('blob');

      this.webapiService
        .request(request)
        .subscribe(blob => {

          this.fileManagementService
            .downloadBlobFromAPIResult(blob, `Acuse_${this.existingData?.Oid}`)

        })

    }, 2000); //Diamo il tempo del salvataggio sopra

  }

  wrapActionInPromise(action: (param: any) => void, param: any): Promise<void> {
    return new Promise((resolve, reject) => {
      try {
        action(param);
        resolve(); // Se non c'è un errore, risolvi la Promise
      } catch (error) {
        reject(error); // Se c'è un errore, rifiuti la Promise
      }
    });
  }

  /**
   * Apre la modale per visualizzare i log degli eventi del WorkOrder corrente
   * Utilizza il WorkOrderEventLogDialogComponent con il filtro sul WorkOrder.Oid
   */
  openEventLogDialog(): void {
    // Verifica che ci sia un WorkOrder.Oid valido
    if (!this.pId) {
      console.warn('Impossibile aprire i log eventi: WorkOrder.Oid non disponibile');
      return;
    }

    const workOrderOid = +this.pId;

    // Configura i dati da passare alla modale
    const dialogData: WorkOrderEventLogDialogData = {
      workOrderOid: workOrderOid
    };

    // Apre la modale utilizzando MatLegacyDialog
    const dialogRef = this.dialogService.open(WorkOrderEventLogDialogComponent, {
      width: '90vw', // Larghezza responsive
      maxWidth: '90vw', // Larghezza massima
      minWidth: '600px', // Larghezza minima
      height: '80vh', // Altezza della modale
      data: dialogData,
      disableClose: false, // Permette di chiudere cliccando fuori
      autoFocus: false // Non fa il focus automatico per evitare problemi con la datatable
    });

    // Gestisce la chiusura della modale se necessario
    dialogRef.afterClosed().subscribe(result => {
      // Al momento non sono necessarie azioni particolari alla chiusura
      // Questo subscribe può essere utilizzato per future implementazioni
    });
  }


}

export interface WorkOrderDefaultEditViewModel {
  workOrder: CTWorkOrder<CtWorkOrderInformationContent> | null;
  workOrderViewType: CTMWorkOrderViewType | null;
  workOrderRowHandlingEnabled: boolean;
  workOrderExtraDataEnabled: boolean;
  workOrderCalendarEnabled: boolean;
  selectedIndex: number;
  masterDetail: boolean;
  offerEnabled: boolean;
}

export class WorkOrderDynamicTabFormConfiguration {

  visible: boolean = true;
  dynamicForms: Array<any> = []
  exportExcel: boolean = false;
  actionExcel: string = 'ExportExcelWorkOrderDynamicForm';

  public static create = () => new WorkOrderDynamicTabFormConfiguration();

  constructor() { }

  setDynamicForms(value: Array<any>) {

    this.dynamicForms = value;
    return this;

  }

}
